import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './common/rem'
import './common/resize'

import '@/common/directive' // 引入全局自定义指令

import '@/assets/styles/animation.scss'
import i18n from './i18n'

Vue.config.productionTip = false

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
